import { Button, Grid, TextField } from "@mui/material";
import { useMaterialUIController } from "context";
import { useEffect, useState } from "react";
import getText from "Translator";
import moment from "moment";
import AdapterJalali from "@date-io/date-fns-jalali";

import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export default function SelectDateComponent(props) {
  const { editQuestionValueHandle, selectedQuestion, handleClose, setFocuse } =
    props;

  const [year, setYear] = useState(0);
  const [month, setMonth] = useState(0);
  const [day, setDay] = useState(0);
  const [selectedDate, setSelectedDate] = useState(
    selectedQuestion.useranswer === ""
      ? new Date()
      : selectedQuestion.useranswer
  );

  const [mode, setMode] = useState("day");
  const [controller, dispatch] = useMaterialUIController();

  const changeDate = (value) => {
    setSelectedDate(value);
  };
  useEffect(() => {
    if (selectedQuestion.useranswer !== "") {
      let selectedMoment = selectedQuestion.useranswer;
      let yy = moment(new Date()).diff(moment(selectedMoment), "year");
      setYear(yy);
      selectedMoment = moment(selectedMoment).add(yy, "year");

      let mm = moment(new Date()).diff(selectedMoment, "month");
      setMonth(mm);
      selectedMoment = selectedMoment.add(mm, "month");

      let dd = moment(new Date()).diff(selectedMoment, "day");
      setDay(dd);
    }
  }, []);
  return (
    <>
      {mode === "day" && (
        <>
          <Grid
            container
            style={{ marginTop: 15, flex: 1, flexDirection: "row" }}
          >
            <Grid item xs={4} sm={4} md={4} style={{ padding: 8 }}>
              <TextField
                fullWidth={true}
                value={year}
                type="tel"
                label={getText("yearago", "fa")}
                max={200}
                min={0}
                onFocus={(event) => {
                  if (event.target.value === "0") {
                    setYear("");
                  }
                }}
                onBlur={(event) => {
                  if (event.target.value === "") {
                    setYear(0);
                  }
                }}
                onChange={(event) => {
                  let val = parseInt(event.target.value, 10);
                  if (
                    event.target.value.length > 0 &&
                    event.target.value.startsWith("0")
                  ) {
                    setYear(event.target.value.substring(1));
                  } else if (val > 120) {
                    setYear(120);
                  } else if (val < 0) {
                    setYear(0);
                  } else {
                    setYear(event.target.value);
                  }
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} style={{ padding: 8 }}>
              <TextField
                fullWidth={true}
                value={month}
                type="number"
                label={getText("monago", "fa")}
                onFocus={(event) => {
                  if (event.target.value === "0") {
                    setMonth("");
                  }
                }}
                onBlur={(event) => {
                  if (event.target.value === "") {
                    setMonth(0);
                  }
                }}
                onChange={(event) => {
                  let val = parseInt(event.target.value, 10);
                  if (
                    event.target.value.length > 0 &&
                    event.target.value.startsWith("0")
                  ) {
                    setMonth(event.target.value.substring(1));
                  } else if (val > 12) {
                    setMonth(12);
                  } else if (val < 0) {
                    setMonth(0);
                  } else {
                    setMonth(event.target.value);
                  }
                }}
                variant="outlined"
              />
            </Grid>
            <Grid item xs={4} sm={4} md={4} style={{ padding: 8 }}>
              <TextField
                fullWidth={true}
                value={day}
                type="number"
                label={getText("dayago", "fa")}
                onFocus={(event) => {
                  if (event.target.value === "0") {
                    setDay("");
                  }
                }}
                onBlur={(event) => {
                  if (event.target.value === "") {
                    setDay(0);
                  }
                }}
                onChange={(event) => {
                  let val = parseInt(event.target.value, 10);
                  if (
                    event.target.value.length > 0 &&
                    event.target.value.startsWith("0")
                  ) {
                    setDay(event.target.value.substring(1));
                  } else if (val > 31) {
                    setDay(31);
                  } else if (val < 0) {
                    setDay(0);
                  } else {
                    setDay(event.target.value);
                  }
                }}
                variant="outlined"
              />
            </Grid>
          </Grid>
          <Grid
            container
            style={{ padding: 15, flex: 1, flexDirection: "row-reverse" }}
          >
            <Button
              color="primary"
              startIcon={<ExpandMoreIcon />}
              onClick={() => {
                setMode("calendar");
                let dd = day * -1;
                let mm = month * -1;
                let yy = year * -1;

                let selectedMoment = new Date();
                let contractMoment = moment(selectedMoment, "YYYY/MM/DD");
                if (year > 0) {
                  contractMoment = moment(contractMoment).add(yy, "year");
                }
                if (month > 0) {
                  contractMoment = moment(contractMoment).add(mm, "month");
                }
                if (day > 0) {
                  contractMoment = moment(contractMoment).add(dd, "day");
                }
                setSelectedDate(contractMoment);
              }}
            >
              {getText("showcalendar", "fa")}
            </Button>
          </Grid>
        </>
      )}
      {mode === "calendar" && controller.dateMode == "fa" && (
        <LocalizationProvider dateAdapter={AdapterJalali}>
          <StaticDatePicker
            orientation="landscape"
            openTo="day"
            value={selectedDate}
            onChange={(value) => {
              console.log(value);
              changeDate(value);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      )}
      {mode === "calendar" && controller.dateMode !== "fa" && (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <StaticDatePicker
            orientation="landscape"
            openTo="day"
            value={selectedDate}
            onChange={(value) => {
              console.log(value);
              changeDate(value);
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      )}

      {/* {mode === "calendar" && (
        <>
          <div className="datecomponent">
            <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
              <DatePicker
                autoOk
                orientation="portrait"
                variant="static"
                openTo="date"
                value={selectedDate}
                onChange={(value) => changeDate(value)}
                onMonthChange={(value) => {
                  changeDate(value);
                }}
              />
            </MuiPickersUtilsProvider>
          </div>

          <Grid
            container
            style={{ padding: 15, flex: 1, flexDirection: "row-reverse" }}
          >
            <Button
              color="primary"
              startIcon={<ExpandLessIcon />}
              onClick={() => {
                setMode("day");
                let selectedMoment = selectedDate;
                let yy = moment(new Date()).diff(
                  moment(selectedMoment),
                  "year"
                );
                setYear(yy);
                selectedMoment = moment(selectedMoment).add(yy, "year");

                let mm = moment(new Date()).diff(selectedMoment, "month");
                setMonth(mm);
                selectedMoment = selectedMoment.add(mm, "month");

                let dd = moment(new Date()).diff(selectedMoment, "day");
                setDay(dd);
              }}
            >
              {getText("hidecalendar", "fa")}
            </Button>
          </Grid>
        </>
      )} */}

      <Grid
        container
        style={{
          marginTop: 5,

          flex: 1,
          flexDirection: "row",
          justifyContent: "space-evenly",
        }}
      >
        <Button
          color="primary"
          onClick={() => {
            handleClose();
          }}
        >
          {getText("cancel", "fa")}
        </Button>

        <Button
          color="primary"
          onClick={() => {
            setDay(0);
            setMonth(0);
            setYear(0);
            setSelectedDate(new Date());
            setFocuse();
            editQuestionValueHandle(selectedQuestion, new Date());
            handleClose();
          }}
        >
          {getText("today", "fa")}
        </Button>

        <Button
          color="primary"
          onClick={() => {
            if (mode === "day") {
              let dd = day * -1;
              let mm = month * -1;
              let yy = year * -1;

              let contractMoment = new Date();
              contractMoment = moment(contractMoment).add(yy, "year");
              contractMoment = moment(contractMoment).add(mm, "month");
              contractMoment = moment(contractMoment).add(dd, "day");
              setSelectedDate(contractMoment);
              setFocuse();
              editQuestionValueHandle(
                selectedQuestion,
                contractMoment.toDate()
              );
            } else {
              setFocuse();
              editQuestionValueHandle(selectedQuestion, selectedDate);
            }
            handleClose();
          }}
        >
          {getText("submit", "fa")}
        </Button>
        <Button
          color="primary"
          onClick={() => {
            setFocuse();
            editQuestionValueHandle(selectedQuestion, "");
            handleClose();
          }}
        >
          {getText("clear", "fa")}
        </Button>
      </Grid>
    </>
  );
}
